import * as types from "./chat.constant";

const defaultState = {
    chats:{},
    newMessage:"",
    user:null,
    group:null,
    gameId:null,
    chatId:"",
    pageNumber:1 ,
    inProgress:false,
    isConnected:0,
    uuid:null,
    chatsIsSynced:false

};

export default function (state = defaultState, action = {}) {
    switch (action.type) {
        case types.CHAT_ACTION_PERSIST:
            return {
                ...state,
                ...action.payload,
            };
        case types.CHAT_ACTION_CLEAR:
            return defaultState;
        default:
            return state;
    }
}
